module.exports = __webpack_public_path__ + "static/media/soket.097cda62.png";